// «Zamorozka» masshtaba na 100%: blokiruem vse sluchaynye sposoby zuma —
// Ctrl/Cmd + koleso, Ctrl/Cmd + (+ / - / = / 0), pinch (touch) i Safari-zhesty.
// ВАЖNO: browser-zoom iz menyu (toolbar) sajt perekryt NE mozhet — eto zashishyonnaya
// nastroyka brauzera. Eto lish otsekaet nechayannyy zum kolesom/klaviaturoy/pinchem.
export function lockZoom() {
  // Ctrl/Cmd + koleso myshi (desktop zoom)
  window.addEventListener('wheel', (e) => {
    if (e.ctrlKey || e.metaKey) e.preventDefault();
  }, { passive: false });

  // Ctrl/Cmd + [ + - = _ 0 ] (klaviaturnyy zoom)
  window.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '_', '0'].includes(e.key)) {
      e.preventDefault();
    }
  });

  // Pinch-zoom na touch (dva paltsa)
  document.addEventListener('touchmove', (e) => {
    if (e.touches && e.touches.length > 1) e.preventDefault();
  }, { passive: false });

  // Safari (iOS/macOS) pinch-zhesty
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((t) => {
    window.addEventListener(t, (e) => e.preventDefault());
  });

  // Double-tap zoom (touch)
  let lastTouch = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouch <= 300) e.preventDefault();
    lastTouch = now;
  }, { passive: false });
}
